import React from 'react';
import './demo.css';

/**
 * 실제 앱 창처럼 보이는 데모 테두리. 처음 온 선생님이 보기 편하도록 상단에는 제목과 재생 버튼만 둔다.
 */
const DemoFrame = ({
  title,
  label,
  player,
  className = '',
  children,
  footer = null,
}) => {
  const showControl = player && !player.reduced;
  const controlLabel = player?.done ? '다시 보기' : player?.paused ? '이어 보기' : '멈추기';
  const onControl = () => {
    if (!player) return;
    if (player.done) player.replay();
    else player.togglePause();
  };

  return (
    <figure
      ref={player?.ref}
      className={`wqdemo-frame ${className}`.trim()}
      aria-label={label || `${title} 예시 화면`}
    >
      <div className="wqdemo-frame-bar">
        <span className="wqdemo-frame-title">{title}</span>
        {showControl && (
          <button type="button" className="wqdemo-control" onClick={onControl}>
            {controlLabel}
          </button>
        )}
      </div>
      <div className="wqdemo-frame-body">{children}</div>
      {footer}
    </figure>
  );
};

export default DemoFrame;
